import { alpha, type Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const IndividualOwnersWorkerCompensationWarningMessageWrapper: StyleExtend<Theme> = {
  gap: 1.25,
  m: (theme) => theme.spacing(6, 0, -4),
  alignItems: 'center',
  flexDirection: 'row',
  borderRadius: 1,
  p: 1.5,
  background: (theme) => alpha(theme.palette.customColors.orange100 as string, 0.1),
  '&:first-of-type': {
    borderRadius: (theme) => theme.spacing(0.5),
  },
  borderLeft: (theme) => `${theme.spacing(1)} solid ${theme.palette.customColors.orange100}`,
  '.workers-compensation-warning-icon': {
    svg: {
      width: (theme) => theme.spacing(3),
      height: (theme) => theme.spacing(3),
      path: {
        fill: (theme) => theme.palette.customColors.orange100,
        stroke: (theme) => theme.palette.customColors.white50,
      },
    },
  },
};
